export enum EModal {
  '提示',
  '恭喜获得',
  '领取记录',
  '充值区服',
  '选择游戏',
  '赠送记录'
}

export enum EButton {
  '每日免费-领取',
  '每日充值-领取',
  '月度充值-领取',
  '折扣-折扣购买',
  '折扣-原价购买',
  '弹窗-回到游戏',
  '弹窗-前往充值',
  '弹窗-好的',
  '弹窗-确定'
}

export enum EModalTitle {
  '充值区服',
  '领取记录',
  '提示',
  '恭喜获得',
  '选择游戏',
  '赠送记录',
}
